const StudentCapacityBox = ({ keyText, valueText }) => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        backgroundColor: "#F6F8FA",
        padding: "12px 16px",
        width: "25%",
        gap: "16px",
      }}
    >
      <div
        style={{
          fontSize: "20px",
          fontWeight: "bold",
        }}
      >
        {keyText}
      </div>
      <div
        style={{
          fontSize: "24px",
          fontWeight: "bold",
          color: "#438CFB",
          textAlign: "right",
        }}
      >
        {valueText}
      </div>
    </div>
  );
};

export default StudentCapacityBox;
